"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _ExtendReactlytics = _interopRequireDefault(require("./ExtendReactlytics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/jsx-props-no-spreading */
var withExtendedReactlytics = function withExtendedReactlytics(overrideAnalytics) {
  return function (WrappedComponent) {
    var AnalyticsWrapper = function AnalyticsWrapper(props) {
      return _react.default.createElement(_ExtendReactlytics.default, {
        analytics: overrideAnalytics
      }, _react.default.createElement(WrappedComponent, props));
    };

    var HoistedAnalyticsWrapper = (0, _hoistNonReactStatics.default)((0, _react.memo)(AnalyticsWrapper), WrappedComponent);
    HoistedAnalyticsWrapper.displayName = "withExtendedReactlytics(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return HoistedAnalyticsWrapper;
  };
};

var _default = withExtendedReactlytics;
exports.default = _default;